import React from 'react';
import CreatableSelect from 'react-select/creatable';

interface TagOption {
  value: any;
  label: string;
}

export interface DetailsTagsFieldProps {
  canManageTags: boolean;
  tagOptions: TagOption[];
  selectedTags: any[];
  onChangeTags: (newValue: any, actionMeta: any) => void;
}

const DetailsTagsField = ({
  canManageTags,
  tagOptions,
  selectedTags,
  onChangeTags,
}: DetailsTagsFieldProps) => {
  if (!canManageTags) {
    return null;
  }

  return (
    <div className="details-tags-field">
      <label className="textarea__label">Tags</label>
      <CreatableSelect
        placeholder="Add or create tags"
        closeMenuOnSelect={false}
        isClearable
        isMulti
        options={tagOptions}
        value={selectedTags}
        onChange={(newValue: any, actionMeta: any) =>
          onChangeTags(newValue, actionMeta)
        }
      />
    </div>
  );
};

export default DetailsTagsField;